import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "loading", "loadMoreButton"]
  static values = {
    voteId: String
  }

  declare readonly listTarget: HTMLElement
  declare readonly loadingTarget: HTMLElement
  declare readonly voteIdValue: string
  declare readonly loadMoreButtonTarget: HTMLElement
  private previousUrl: string | null = null
  private currentOffset: number = 0

  showLoading(): void {
    this.loadingTarget.style.display = 'block'

    // Initialize offset from the current answers count
    const questions = this.listTarget.querySelectorAll('[data-question-id]')
    this.currentOffset = questions.length
  }

  hideLoading(): void {
    this.loadingTarget.style.display = 'none'
  }

  handleLoadMore(event: Event): void {
    this.previousUrl = window.location.href

    requestAnimationFrame(() => {
      window.history.pushState({}, '', this.previousUrl)
    })
  }
}
